export default __webpack_public_path__ + "static/media/struct11.7ad6ac98.png";